<template>
    <button
        class="
          size-[48px] cursor-pointer rounded-full bg-center bg-no-repeat outline-none focus-outline-only

          disabled:opacity-40
        "

        :disabled="disabled"

        :style="{
            backgroundColor: `#${color.hex}`,
            backgroundImage: `url(&quot;${color.pattern}&quot;)`,
            backgroundSize: '120%',
            border: isSelected ? `2px solid black` : 'none',
            boxShadow: isSelected ? `0 0 0 0 rgba(0, 0, 0, 0.2), inset 0 0 0 3px white` : 'none',
        }"

        :aria-label="color.text"

        :title="color.text"

        @click="$emit('select', color)"
    />
</template>

<script>
    export default {
        name: 'ColorSwatch',

        props: {
            color: {
                type: Object,
                required: true,
            },
            isSelected: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
